module.exports = __webpack_public_path__ + "static/img/urban.4eae538c.png";